import { render, staticRenderFns } from "./storeGoodsAfterSetSeparate.vue?vue&type=template&id=2950d071&scoped=true&"
import script from "./storeGoodsAfterSetSeparate.vue?vue&type=script&lang=js&"
export * from "./storeGoodsAfterSetSeparate.vue?vue&type=script&lang=js&"
import style0 from "./storeGoodsAfterSetSeparate.vue?vue&type=style&index=0&id=2950d071&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950d071",
  null
  
)

component.options.__file = "storeGoodsAfterSetSeparate.vue"
export default component.exports